/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Initiate a document distribution
 * @export
 * @interface DocumentDeliveryRequest
 */
export interface DocumentDeliveryRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof DocumentDeliveryRequest
     */
    documentIds?: Array<number>;
}

/**
 * Check if a given object implements the DocumentDeliveryRequest interface.
 */
export function instanceOfDocumentDeliveryRequest(value: object): value is DocumentDeliveryRequest {
    return true;
}

export function DocumentDeliveryRequestFromJSON(json: any): DocumentDeliveryRequest {
    return DocumentDeliveryRequestFromJSONTyped(json, false);
}

export function DocumentDeliveryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentDeliveryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'documentIds': json['documentIds'] == null ? undefined : json['documentIds'],
    };
}

export function DocumentDeliveryRequestToJSON(json: any): DocumentDeliveryRequest {
    return DocumentDeliveryRequestToJSONTyped(json, false);
}

export function DocumentDeliveryRequestToJSONTyped(value?: DocumentDeliveryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentIds': value['documentIds'],
    };
}

